import React from 'react';
export function PrivacyPolicy() {
  return <div className="prose prose-sm max-w-none" data-id="element-275">
      <p className="text-gray-600 mb-4" data-id="element-276">
        <strong data-id="element-277">Última actualización:</strong> Enero 2025
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-278">
        1. Información que Recopilamos
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-279">
        Recopilamos información que nos proporcionas directamente cuando:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-280">
        <li data-id="element-281">Compras nuestro sistema de recetas</li>
        <li data-id="element-282">Te suscribes a nuestro newsletter</li>
        <li data-id="element-283">Nos contactas para soporte</li>
        <li data-id="element-284">Participas en nuestra comunidad</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-285">2. Uso de la Información</h3>
      <p className="text-gray-700 mb-4" data-id="element-286">Utilizamos tu información para:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-287">
        <li data-id="element-288">Procesar tus compras y enviarte el contenido digital</li>
        <li data-id="element-289">Enviarte actualizaciones del producto y recetas nuevas</li>
        <li data-id="element-290">Responder a tus consultas y brindarte soporte</li>
        <li data-id="element-291">Mejorar nuestros productos y servicios</li>
        <li data-id="element-292">Cumplir con obligaciones legales</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-293">3. Protección de Datos</h3>
      <p className="text-gray-700 mb-4" data-id="element-294">
        Implementamos medidas de seguridad para proteger tu información
        personal:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-295">
        <li data-id="element-296">Encriptación SSL en todas las transacciones</li>
        <li data-id="element-297">Servidores seguros y protegidos</li>
        <li data-id="element-298">Acceso limitado a información personal</li>
        <li data-id="element-299">Cumplimiento con GDPR y regulaciones internacionales</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-300">4. Cookies</h3>
      <p className="text-gray-700 mb-4" data-id="element-301">
        Utilizamos cookies para mejorar tu experiencia en nuestro sitio. Puedes
        configurar tu navegador para rechazar cookies, aunque esto puede afectar
        algunas funcionalidades del sitio.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-302">5. Compartir Información</h3>
      <p className="text-gray-700 mb-4" data-id="element-303">
        No vendemos ni compartimos tu información personal con terceros,
        excepto:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-304">
        <li data-id="element-305">Procesadores de pago necesarios para completar transacciones</li>
        <li data-id="element-306">
          Proveedores de servicios que nos ayudan a operar nuestro negocio
        </li>
        <li data-id="element-307">Cuando sea requerido por ley</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-308">6. Tus Derechos</h3>
      <p className="text-gray-700 mb-4" data-id="element-309">Tienes derecho a:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-310">
        <li data-id="element-311">Acceder a tu información personal</li>
        <li data-id="element-312">Corregir información incorrecta</li>
        <li data-id="element-313">Solicitar la eliminación de tus datos</li>
        <li data-id="element-314">Cancelar suscripciones en cualquier momento</li>
        <li data-id="element-315">Presentar una queja ante autoridades de protección de datos</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-316">7. Contacto</h3>
      <p className="text-gray-700 mb-4" data-id="element-317">
        Para cualquier consulta sobre esta política de privacidad, contáctanos
        a:
        <br data-id="element-318" />
        <strong data-id="element-319">Email:</strong> recetasexpresslatam@gmail.com
      </p>
    </div>;
}